// extracted by mini-css-extract-plugin
export default {"__":"loading_____4CudR","circle":"loading_circle__X3q+m","wave":"loading_wave__xPTJ0","animate":"loading_animate__DWIty"};